import React, { memo } from "react";
import type { IconProps } from "./_IconProps";

const PlusCircle = ({ color, size }: IconProps) => (
  <svg
    width={size || "24px"}
    height={size || "24px"}
    viewBox="0 0 24 24"
    version="1.1"
  >
    <g
      id="ic/add_circle-w"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon id="bounds" points="0 0 24 0 24 24 0 24"></polygon>
      <path
        d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M17,13 L13,13 L13,17 L11,17 L11,13 L7,13 L7,11 L11,11 L11,7 L13,7 L13,11 L17,11 L17,13 Z"
        id="Shape"
        fill={color || "#FFFFFF"}
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);

export default memo(PlusCircle);
